import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";

import { testLocator } from "@/lib/helpers/test-locator";

import ExpandableMessageInput from "../ExpandableMessageInput/ExpandableMessageInput";
import { getAutomationDataAttr } from "../../../../utils/automationUtils";
import { isConversationReadOnly, CONVERSATION_READ_ONLY_TYPES } from "../../../../utils/chatUtils";
import { Link } from "../../../../component-library";
import { MAX_CHAT_LENGTH_MESSAGE } from "../constants";
import { SUPPORT_NUMBER, SUPPORT_NUMBER_HREF } from "../../../../constants/aptihealth";

export const ChatFooter = (props) => {
  const { channel, isInactive, sendMessage } = props;
  const profile = useSelector((state) => state.auth.profile);

  const renderFooter = () => {
    const isReadOnly = isConversationReadOnly(profile?.care_team_members, channel);
    const providerName = channel.otherMembers[0].nickname;

    if (isInactive) {
      return (
        <div className="input-disabled">
          Your account is currently inactive. Looking to send a message? Please email us at{" "}
          <a className="support-email-link" href="mailto:support@aptihealth.com">
            support@aptihealth.com
          </a>{" "}
          or call us at{" "}
          <a className="support-email-link" href={SUPPORT_NUMBER_HREF}>
            {SUPPORT_NUMBER}
          </a>
          .{" "}
        </div>
      );
    } else if (isReadOnly === CONVERSATION_READ_ONLY_TYPES.PROVIDER_NO_LONGER_ON_CARE_TEAM) {
      return (
        <div className="input-disabled">
          {providerName} is no longer on your care team. You can still view old messages, but you
          can't reply to this thread.
        </div>
      );
    } else if (isReadOnly === CONVERSATION_READ_ONLY_TYPES.PATIENT_READ_ONLY_THREAD) {
      return (
        <div
          className="input-disabled"
          {...getAutomationDataAttr("chat-footer-patient-read-only-thread")}
          {...testLocator("patientReadOnlyThreadBanner")}
        >
          <b>Replies have been turned off for this thread</b>, but you can still view and receive
          updates from {providerName}. If you need to contact {providerName}, please reach out to{" "}
          <Link href="mailto:support@aptihealth.com">support@aptihealth.com</Link>, and our team
          will assist you.
        </div>
      );
    }

    return (
      <ExpandableMessageInput
        channel={channel}
        maxLength={MAX_CHAT_LENGTH_MESSAGE}
        submitHandler={sendMessage}
      />
    );
  };

  return <div className="Messages__Chat__Footer">{renderFooter()}</div>;
};

ChatFooter.propTypes = {
  channel: PropTypes.object.isRequired,
  isInactive: PropTypes.bool.isRequired,
  sendMessage: PropTypes.func.isRequired,
};
